import { render, staticRenderFns } from "./PromoConditions.vue?vue&type=template&id=2608a10e&"
import script from "./PromoConditions.vue?vue&type=script&lang=js&"
export * from "./PromoConditions.vue?vue&type=script&lang=js&"
import style0 from "./PromoConditions.vue?vue&type=style&index=0&id=2608a10e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports